<ng-container *ngIf="cart && !showExistingCartFlow && !showExistingCartoption">
  <div [cxFocus]="focusConfig" (esc)="close('Escape clicked')" class="cx-saved-cart-form-dialog">
    <form [formGroup]="form" class="cx-saved-cart-form-container">
      <!-- Modal Header -->
      <div class="modal-header cx-saved-cart-form-header">
        <ng-container [ngSwitch]="layoutOption">
          <div class="cx-saved-cart-form-title modal-title">

            <ng-container>
              {{'common.basket_save_cart'|cxTranslate}}
            </ng-container>
          </div>
        </ng-container>

        <button (click)="close('Close Save Cart Dialog')" [disabled]="isLoading$ | async"
          [attr.aria-label]="'common.close' | cxTranslate" class="cx-saved-cart-form-close close" type="button">
          <span aria-hidden="true">
            <cx-icon [type]="iconTypes.CLOSE"></cx-icon>
          </span>
        </button>
      </div>

      <!-- Modal Body -->
      <div class="cx-saved-cart-form-body">
        <!-- start DELETE and RESTORE form -->
        <ng-container *ngIf="
            layoutOption === savedCartFormType.DELETE ||
              layoutOption === savedCartFormType.RESTORE;
            else saveAndEditCart
          ">

          <div class="cx-saved-cart-form-row">
            <div class="cx-saved-cart-values-container">
              <div class="cx-saved-cart-label uppercase">
                {{'common.basket_save_cart_name'|cxTranslate}}
              </div>
              <div class="cx-saved-cart-value">
                {{ cart?.name }}
              </div>
            </div>

            <div class="cx-saved-cart-values-container">
              <div class="cx-saved-cart-label uppercase">
                {{'common.basket_save_cart_description'|cxTranslate}}
              </div>
              <div class="cx-saved-cart-value">
                {{ cart?.code }}
              </div>
            </div>

            <div class="cx-saved-cart-values-container">
              <div class="cx-saved-cart-label uppercase">
                {{'common.basket_save_cart_description'|cxTranslate}}
              </div>
              <div class="cx-saved-cart-value">
                {{ cart?.description }}
              </div>
            </div>

            <div class="cx-saved-cart-values-container">
              <div class="cx-saved-cart-label">
                {{ 'savedCartDialog.quantity' | cxTranslate }}
              </div>
              <div class="cx-saved-cart-value">
                {{ cart?.totalUnitCount }}
              </div>
            </div>

            <div class="cx-saved-cart-values-container">
              <div class="cx-saved-cart-label">
                {{ 'savedCartDialog.total' | cxTranslate }}
              </div>
              <div class="cx-saved-cart-value">
                {{ cart?.totalPriceWithTax?.formattedValue }}
              </div>
            </div>
          </div>

          <div class="cx-saved-cart-form-footer">
            <button (click)="close('Close Save Cart Dialog')" [attr.aria-label]="'common.close' | cxTranslate"
              class="mr-2 btn btn-secondary" type="button">
              {{ 'savedCartDialog.cancel' | cxTranslate }}
            </button>

            <ng-container *ngIf="
                layoutOption === savedCartFormType.DELETE;
                else isRestoreSavedCart
              ">
              <button *ngIf="cart.code" (click)="deleteCart(cart.code)"
                [attr.aria-label]="'common.delete' | cxTranslate" [disabled]="isDisableDeleteButton$ | async"
                class="ml-2 btn btn-primary" type="button">
                {{ 'savedCartDialog.delete' | cxTranslate }}
              </button>
            </ng-container>

            <ng-template #isRestoreSavedCart>
              <button *ngIf="cart.code" (click)="restoreSavedCart(cart.code)"
                [disabled]="isDisableRestoreButton$ | async" [attr.aria-label]="'common.restore' | cxTranslate"
                class="ml-2 btn btn-primary" type="button">
                {{ 'savedCartDialog.restore' | cxTranslate }}
              </button>
            </ng-template>
          </div>
        </ng-container>
        <!-- end DELETE form -->

        <!-- start SAVE and EDIT form -->
        <ng-template #saveAndEditCart>


          <div class="cx-saved-cart-form-row">
            <ng-container>
              <label>
                <span
                  class="cx-saved-carts-label label-content uppercase">{{'common.basket_save_cart_name'|cxTranslate}}</span>
                <input required="true" [maxLength]="nameMaxLength" class="form-control" formControlName="name" required
                  type="text" />
                <cx-form-errors [control]="form.get('name')"></cx-form-errors>
              </label>
            </ng-container>
          </div>

          <div class="cx-saved-cart-form-row">
            <label>
              <span
                class="cx-saved-carts-label label-content uppercase">{{'common.basket_save_cart_description'|cxTranslate}}
              </span>
              <textarea [maxLength]="descriptionMaxLength" class="form-control outline" formControlName="description"
                rows="5"></textarea>
              <cx-form-errors [control]="form.get('description')"></cx-form-errors>

              <p class="cx-saved-carts-input-hint">
                {{
                'common.basket_save_cart_max_chars'
                | cxTranslate
                }}: {{descriptionMaxLength - form?.controls['description']?.value.length}}
              </p>
            </label>
          </div>
          <div class="cx-saved-cart-form-footer">
            <button (click)="saveNewCart(cart?.code)" [attr.aria-label]="'common.save' | cxTranslate"
              [disabled]="isLoading$ | async" class="btn save-btn" type="button">
              {{ 'common.basket_save_cart_action_save' | cxTranslate }}
              <img src="/icons/link-dark-grey.svg" class="icon-right" alt="">
            </button>
            <button (click)="close('Close Save Cart Dialog')" [attr.aria-label]="'common.close' | cxTranslate"
              [disabled]="isLoading$ | async" class="btn btn-secondary cancel-btn" type="button">
              {{ 'common.checkout_multi_cancel' | cxTranslate }}
            </button>

          </div>
        </ng-template>
        <!-- end SAVE and EDIT form -->
      </div>
    </form>
  </div>
</ng-container>
<ng-container *ngIf="cart && showExistingCartFlow && !showExistingCartoption">
  <div [cxFocus]="focusConfig" (esc)="close('Escape clicked')" class="cx-saved-cart-form-dialog">
    <form [formGroup]="form" class="cx-saved-cart-form-container">
      <!-- Modal Header -->
      <div class="modal-header cx-saved-cart-form-header">
        <ng-container [ngSwitch]="layoutOption">
          <div class="cx-saved-cart-form-title modal-title">
            {{'common.basket_save_cart'|cxTranslate}}
          </div>
        </ng-container>

        <button (click)="close('Close Save Cart Dialog')" [disabled]="isLoading$ | async"
          [attr.aria-label]="'common.close' | cxTranslate" class="cx-saved-cart-form-close close" type="button">
          <span aria-hidden="true">
            <cx-icon [type]="iconTypes.CLOSE"></cx-icon>
          </span>
        </button>
      </div>

      <!-- Modal Body -->
      <div class="cx-saved-cart-form-body cart-radio d-flex flex-column">
        <div class="saved-cart-radio-section">
          <input type="radio" id="contactChoice1" class="radio-selection" name="contact" value="existing"
            (change)="onItemChange($event)">
          <label for="Choice1"
            class="uppercase saved-cart-radio-label">{{'common.choose_from_existing'|cxTranslate}}</label>
        </div>
        <div class="saved-cart-radio-section">
          <input type="radio" id="contactChoice2" class="radio-selection" name="contact" value="new"
            (change)="onItemChange($event)">
          <label for="Choice1" class="uppercase saved-cart-radio-label">{{'common.save_a_new_cart'|cxTranslate}}</label>
        </div>
      </div>
      <div class="cx-saved-cart-form-footer cart-save-radio-footer">
        <button (click)="nextClick()" [attr.aria-label]="'common.close' | cxTranslate"
          class="mr-2 btn btn-secondary col-sm-6 next-btn uppercase" type="button" [disabled]="selectedOption==''">
          {{'common.checkout_multi_deliveryMethod_continue'|cxTranslate}}
          <img src="/icons/link-dark-grey.svg" class="icon-right" alt="">
        </button>

        <button (click)="close('Close Save Cart Dialog'); selectedOption=''"
          [attr.aria-label]="'common.close' | cxTranslate" class="mr-2 btn btn-secondary col-sm-6  cancel-btn uppercase"
          type="button">
          {{'common.checkout_multi_cancel'|cxTranslate}}
        </button>
      </div>
    </form>
  </div>


</ng-container>
<ng-container *ngIf="cart && showExistingCartoption">
  <div [cxFocus]="focusConfig" (esc)="close('Escape clicked')" class="cx-saved-cart-form-dialog">
    <form [formGroup]="form" class="cx-saved-cart-form-container">
      <!-- Modal Header -->
      <div class="modal-header cx-saved-cart-form-header">
        <ng-container [ngSwitch]="layoutOption">
          <div class="cx-saved-cart-form-title modal-title">
            {{'common.basket_save_cart'|cxTranslate}}
          </div>
        </ng-container>

        <button (click)="close('Close Save Cart Dialog')" [disabled]="isLoading$ | async"
          [attr.aria-label]="'common.close' | cxTranslate" class="cx-saved-cart-form-close close" type="button">
          <span aria-hidden="true">
            <cx-icon [type]="iconTypes.CLOSE"></cx-icon>
          </span>
        </button>
      </div>

      <!-- Modal Body -->
      <div class="cx-saved-cart-form-body cart-radio d-flex flex-column">
        <div *ngFor="let item of savedCartList" class="saved-cart-radio-section">
          <input type="radio" id="contactChoice1" class="radio-selection" name="contact" [value]="item.name"
            (change)="setSelectedSavedCart($event, item)">
          <label for="Choice1" class="uppercase saved-cart-radio-label">{{item.name}}</label>
        </div>

      </div>
      <div class="cx-saved-cart-form-footer d-flex cart-save-radio-footer">
        <button (click)="save(cart.code)" [attr.aria-label]="'common.close' | cxTranslate"
          class="mr-2 btn btn-secondary col-sm-6 next-btn uppercase" type="button"
          [disabled]="selectedSavedCartName==''">
          {{'common.basket_save_cart_action_save'|cxTranslate}}
        </button>

        <button (click)="close('Close Save Cart Dialog'); showExistingCartoption=false"
          [attr.aria-label]="'common.close' | cxTranslate" class="mr-2 btn btn-secondary col-sm-6  cancel-btn uppercase"
          type="button">
          {{'common.checkout_multi_cancel'|cxTranslate}}
        </button>
      </div>
    </form>
  </div>


</ng-container>